import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    const dir = translations[lang]._dir;
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("lang", lang);
  }, [lang]);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      node = node?.[p];
      if (node === undefined) return path;
    }
    return node;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "en" ? "ku" : "en")), []);

  const value = useMemo(() => ({ lang, setLang, toggle, t, dir: translations[lang]._dir }), [lang, toggle, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
